export function isPendingAction(action) {
    return action.type.endsWith('/pending')
}
export function isRejectedAction(action) {
    return action.type.endsWith('/rejected')
}
export function isFullfieldAction(action) {
    return action.type.endsWith('/fulfilled')
}